import { NavLink } from "react-router-dom";
import {
  FaChartBar,
  FaUsers,
  FaUserTie,
  FaBriefcase,
  FaClipboardList,
  FaCreditCard,
  FaFileAlt,
  FaCog,
  FaSignOutAlt,
  FaUserShield,
} from "react-icons/fa";

function Sidebar() {
  const admin = JSON.parse(localStorage.getItem("user"));

  const menuItems = [
    {
  name: "Dashboard",
  path: "/admin/dashboard",
  icon: <FaChartBar />,
   },
    {
      name: "Candidates",
      path: "/admin/candidates",
      icon: <FaUsers />,
    },
    {
      name: "Recruiters",
      path: "/admin/recruiters",
      icon: <FaUserTie />,
    },
    {
      name: "Jobs",
      path: "/admin/jobs",
      icon: <FaBriefcase />,
    },
    {
      name: "Applications",
      path: "/admin/applications",
      icon: <FaClipboardList />,
    },
    {
      name: "Payments",
      path: "/admin/payments",
      icon: <FaCreditCard />,
    },
    {
      name: "Reports",
      path: "/admin/reports",
      icon: <FaFileAlt />,
    },
    {
      name: "Settings",
      path: "/admin/settings",
      icon: <FaCog />,
    },
  ];

  const handleLogout = () => {

    localStorage.clear();

    window.location.href = "/admin/login";

};
  return (
    <div className="w-72 min-h-screen bg-gradient-to-b from-teal-700 to-emerald-800 text-white p-6">

      {/* Logo */}
      <div className="mb-10">
        <div className="flex items-center gap-4">

          <div className="w-16 h-16 rounded-2xl bg-white flex items-center justify-center">

            <FaUserShield
              className="text-teal-700"
              size={28}
            />

          </div>

          <div>
            <h2 className="text-2xl font-bold">
              HIRECURA
            </h2>

            <p className="text-teal-100 text-sm">
              Admin Panel
            </p>
          </div>

        </div>
      </div>

      {/* Admin Name */}
      <div className="mb-8">

        <div className="bg-white/10 rounded-2xl p-4">

          <h3 className="font-bold text-lg">
            {admin?.name || "Administrator"}
          </h3>

          <p className="text-sm text-teal-100">
            System Administrator
          </p>

        </div>

      </div>

      {/* Menu */}
      <div className="space-y-3">

        {menuItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            end={item.path === "/admin/dashboard"}
            className={({ isActive }) =>
              `w-full flex items-center gap-3 p-4 rounded-2xl transition ${
                isActive
                  ? "bg-white text-teal-700"
                  : "hover:bg-white/10"
              }`
            }
          >
            {item.icon}
            {item.name}
          </NavLink>
        ))}

      </div>

      {/* Logout */}
      <div className="mt-10">

        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 p-4 rounded-2xl hover:bg-red-500 transition"
        >
          <FaSignOutAlt />
          Logout
        </button>

      </div>

    </div>
  );
}

export default Sidebar;